<ng-container *ngIf="hasAnyVisibleRisks(); else noRisks">
  <!-- Top Right Legend -->
  <div class="d-flex justify-content-end align-items-center mb-3 px-2 text-dark"
    style="font-size: 13px; font-weight: 500;">
    <!-- RAG Legend -->
    <div class="d-flex align-items-center me-3" style="margin-top:10px">
      <span
        style="background: linear-gradient(45deg, #DD2C54, #f70029a5); width: 16px; height: 16px; border-radius: 3px; margin-right: 6px;"></span>
      <span class="me-4">Not Responded/Overdue</span>
      <span
        style="background: linear-gradient(45deg, #ffc206, #d5c487); width: 16px; height: 16px; border-radius: 3px; margin-right: 6px;"></span>
      <span class="me-4">In Progress</span>
      <span
        style="background: linear-gradient(0deg, #41a064ff, #5edd8dff); width: 16px; height: 16px; border-radius: 3px; margin-right: 6px;"></span>
      <span>Completed/Accepted</span>
    </div>
  </div>

  <div class="table" style="margin-bottom: 0px">
    <div class="table-row" style="position: sticky; top: 0px; z-index: 3; background: white">
      <div class="table-cell cursor-pointer domain fw-bold" style="
        max-width: 150px;
        min-width: 150px;
        width: 150px;
        text-align: left;
        font-size: 14px;
        background: white;
        position: sticky;
        top: 0;
        left: 0;
        z-index: 3;
      ">
        <div style="background-color: #0bb797; border-radius: 10px">Domain</div>
      </div>
      <div class="table-cell table-nest">
        <div class="table-row" style="width: 100%; position: sticky; top: 0; left: 150px; z-index: 3">
          <div class="table-cell cursor-pointer subdomain" style="
            max-width: 150px;
            min-width: 150px;
            width:150px;
            text-align: left;
            font-size: 14px;
            background-color: white;
            position: sticky;
            top: 0;
            left: 150px;
            z-index: 3;
          ">
            <div style="background-color: #0bb797; border-radius: 10px; padding: 8px">
              Sub Domain
            </div>
          </div>
          <div class="table-cell" style="
            max-width: 150px;
            min-width: 150px;
            width:150px;
            padding: 5px;
            cursor: pointer;
            background-color: white;
            color: white;
            position: sticky;
            top: 0;
            left: 0;
            z-index: 2;
          ">
            <span style="
              position: sticky;
              font-size: 14px;
              text-align: left;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 90%;
            ">
              <div style="
                background-color: #0bb797;
                border-radius: 10px;
                padding: 8px;
              ">
                Risk
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="riskCenterList" style="overflow: scroll; height: calc(100vh - 425px)">
    <div class="container-fluid p-0">
      <div class="table">
        <div class="table-row" *ngFor="
          let domain of getFilteredArray(riskArrayHeatMap);
          let subindex = index
        ">
          <div class="table-cell cursor-pointer fw-bold" style="
            max-width: 180px;
            min-width: 150px;
            width: 180px;
            font-size: 14px;
            position: sticky;
            left: 0;
            z-index: 1;
            height: 100px;
          ">
            <div class="domain" [ngStyle]="{
              background: getBackgroundColor(domain?.color)
            }" style="border-radius: 10px; height: 100%">
              {{ domain?.display_name }}
            </div>
          </div>
          <div class="table-cell table-nest" *ngIf="domain.children">
            <div class="table-row" style="position: relative" *ngFor="
              let subdomain of getFilteredArray(domain?.children);
              let subsubindex = index
            ">
              <div class="table-cell cursor-pointer" id="subdomain_{{ subsubindex }}" style="
                max-width: 150px;
                min-width: 150px;
                font-size: 13px;
                position: sticky;
                left: 150px;
                z-index: 2;
                height: 100px;
              ">
                <div class="subdomain" [ngStyle]="{
                  background: getBackgroundColor(subdomain?.color)
                }" style="border-radius: 10px; padding: 8px; height: 100%"
                  [matTooltip]="subdomain?.display_name | titlecase">
                  {{ subdomain?.display_name }}
                </div>
              </div>
              <div class="table-cell" style="
                max-width: 180px;
                min-width: 180px;
                position: relative;
                cursor: pointer;
              " (click)="onClickRisk(domain, subdomain, risk, riskLogPop)" *ngFor="
                let risk of getFilteredArray(subdomain?.children);
                let risksubindex = index
              ">
                <span id="risksubdomain_{{ subsubindex }}_{{ risksubindex }}" style="
                  position: absolute;
                  font-size: 13px;
                  text-align: center;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
                  width: 90%;
                  height: 100%;
                  padding: 5px 0;
                ">
                  <div [ngStyle]="{ background: getBackgroundColor(risk?.color) }" style="
                    border-radius: 10px;
                    padding: 5px 6px;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    overflow: hidden;
                    box-sizing: border-box;
                  ">
                    <!-- Top row: 4 metrics/indicators -->
                    <div
                      style="display: flex; align-items: center; justify-content: space-between; width: 100%; flex-shrink: 0;">
                      <!-- Placeholder 2 / Risk Type -->
                      <span *ngIf="risk?.risk_type?.display_name; else emptyType" class="info-tile"
                        matTooltip="Risk Type: {{risk.risk_type?.display_name}}">{{
                        risk.risk_type?.display_name}}</span>
                      <ng-template #emptyType><span style="width: 14px;"></span></ng-template>

                      <!-- Impact badge -->
                      <span *ngIf="risk?.risk_impact?.display_name; else emptyBadge" class="info-tile"
                        matTooltip="Risk Impact: {{risk.risk_impact?.display_name}}">{{
                        risk.risk_impact?.display_name}}</span>
                      <ng-template #emptyBadge><span style="width: 18px;"></span></ng-template>

                      <!-- Residual Score -->
                      <span class="info-tile" matTooltip="Residual Risk Score: {{risk?.residual_risk_score}}">{{
                        risk?.residual_risk_score ?? '-' }}</span>
                    </div>

                    <!-- Risk name: 2-line clamp -->
                    <div [matTooltip]="risk?.risk_id ? risk.risk_id + ' - ' + risk.display_name : risk.display_name"
                      style="
                    font-size: 12px;
                    color: white;
                    text-align: center;
                    overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    line-height: 1.3;
                    word-break: break-word;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  ">
                      {{
                      getTrucatedName(
                      subdomain?.display_name,
                      (risk?.risk_id ? risk.risk_id + ' - ' + risk.display_name : risk.display_name),
                      risk?.short_description
                      )
                      }}
                    </div>

                    <!-- Bottom: response pill -->
                    <div *ngIf="risk?.status" style="
                    text-align: center;
                    flex-shrink: 0;
                    white-space: nowrap;
                    position: relative;
                  ">
                      <!-- <span style="
                      background: rgba(0,0,0,0.2);
                      border-radius: 3px;
                      padding: 1px 4px;
                      font-size: 10px;
                      color: white;
                      font-weight: 600;
                      display: inline-block;
                      max-width: 80%;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    " matTooltip="Response: {{risk?.risk_response}}">{{ risk?.risk_response }}</span> -->

                      <!-- Closed Checkmark -->
                      <mat-icon
                        *ngIf="risk?.status?.toLowerCase() === 'wip' || risk?.status?.toLowerCase() === 'closed'"
                        matTooltip="Risk Accepted" style="
                          position: absolute;
                          right: -2px;
                          bottom: 0px;
                          font-size: 16px;
                          width: 16px;
                          height: 16px;
                          line-height: 16px;
                          background: white;
                          color: #0bb797;
                          border-radius: 50%;
                        ">check_circle</mat-icon>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #noRisks>
  <div class="riskCenterList d-flex justify-content-center align-items-center" style="height: calc(100vh - 425px);">
    {{ commonText.no_records_found }}
  </div>
</ng-template>